import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_BASE_URI } from "../../http/api";
import { Collection } from "../../http/collection";
import { Store } from "@ngxs/store";
import { Filter, FilterBuilder } from "../../http/filter";
import { Observable } from "rxjs";
import { DetailRequest, DetailRequestBuilder } from "../../http/detail";
import { ReportPage } from "@core/data/types/advanced-report";
import { ReportHttpHelperService } from "./advanced-report-http-helper.service";

@Injectable()
export class ReportPageService {

    constructor(
        @Inject(API_BASE_URI) private _baseUri: string,
        private _http: HttpClient,
        private _httpHelperService: ReportHttpHelperService,
    ) {}

    get(pageKey: string, shareKey: string = null, detail?: DetailRequest): Observable<ReportPage> {
        const params = detail ? DetailRequestBuilder.queryParams(detail) : {};
        return this._http.get<ReportPage>(`${this._baseUri}/report-page/${pageKey}`, this._httpHelperService.withShareKey({params}, shareKey));
    }

    // TODO see if we need to handle create response
    create(model: Partial<ReportPage>): Observable<ReportPage> {
        return this._http.post<ReportPage>(`${this._baseUri}/report-page`, model);
    }

    delete(key: string) {
        return this._http.delete<ReportPage>(`${this._baseUri}/report-page/${key}`);
    }

}